import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AccountsDataService } from './services/accounts.data.service';
import { AccountsService } from './services/accounts.service';
import { AccountEffects } from './store/account.effects';
import { accountReducer } from './store/account.store';

@NgModule({
  imports: [
    // Angular and vendors
    CommonModule,
    StoreModule.forFeature('account', accountReducer),
    EffectsModule.forFeature([AccountEffects]),
  ],
  providers: [
    AccountsDataService,
    AccountsService
  ]
})
export class AccountsModule {}
